import React from 'react'
import { useLocation, useNavigate } from 'react-router'

const SideBarAbout = () => {
  const navigate = useNavigate()
  const location  = useLocation()
  return (
    <div className='grid md:grid-cols-3 bg-white rounded shwadow-lg p-2 mb-2'> {/* min-h-screen */}
      <p className={`border rounded hover:bg-main hover:text-white hover:font-bold p-2 ${location.pathname.split("/")[4] === "regform" ? "bg-main font-bold" : ""}`} onClick={() => navigate(`regform`)}>Formulaire d'inscription</p>
      <p className={`border rounded hover:bg-main hover:text-white hover:font-bold p-2 ${location.pathname.split("/")[4] === "diploms" ? "bg-main font-bold" : ""}`} onClick={() => navigate(`diploms`)}>Diplomes</p>
      {/* <p className={`border rounded hover:bg-main hover:text-white hover:font-bold p-2 ${location.pathname.split("/")[4] === "payments" ? "bg-main font-bold" : ""}`} onClick={() => navigate(`payments`)}>Paiements</p> */}
    </div>
  )
}

export default SideBarAbout